import axios from 'axios';

const {
  REACT_APP_NFT_API
} = process.env;

const nft_api = REACT_APP_NFT_API;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  NFT_GET_PERIOD: () => axios.get(`${nft_api}/claim/period`),
  NFT_GET_NEXT_PERIOD: () => axios.get(`${nft_api}/claim/period/next`),
  GET_WINNERS_LIST: () => axios.post(`${nft_api}/claim/winners`)
}